/**
 * Шина обмена данных между Backbone и React
 */
export const reduxStore = window.app && window.app.reduxStore
